import React from 'react';
import { FaChevronCircleLeft, FaMapMarkerAlt } from 'react-icons/fa';
import { useStyles } from './styles';

interface IBottomBarProps {
  isCreatingOrder: boolean;
  selectedFeatureName?: string;
  onClickOpen: any;
  onClickClear?: any;
}

const ToggleRightBar: React.FC<IBottomBarProps> = ({
  isCreatingOrder,
  selectedFeatureName,
  onClickOpen,
  onClickClear,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.toggleRightBar}>
      <button
        id="open-menu"
        disabled={isCreatingOrder}
        className={classes.toggleButton}
        type="button"
        onClick={onClickOpen}
      >
        <FaChevronCircleLeft
          size={24}
          color={isCreatingOrder ? 'rgba(112, 48, 160, 0.3)' : '#7030A0'}
        />
      </button>
      <button
        id="toggle-location"
        disabled={isCreatingOrder || selectedFeatureName === ''}
        className={classes.toggleButton}
        type="button"
        onClick={onClickClear}
      >
        <FaMapMarkerAlt
          size={24}
          color={
            isCreatingOrder || selectedFeatureName === ''
              ? 'rgba(112, 48, 160, 0.3)'
              : '#7030A0'
          }
        />
      </button>
    </div>
  );
};

export default ToggleRightBar;
